import React from 'react'
import TweetEmbed from 'react-tweet-embed'
import MasonryWall from './MasonryWall'

const TweetEmbedComp = ({ tweets, hiddenState, convState }: any) => tweets.length > 1 ? (
  <MasonryWall>
    {tweets.map((tweet: any, index: number) => (
      <TweetEmbed key={index} id={tweet} options={{ align: 'center', cards: hiddenState, conversation: convState }} />
    ))}
  </MasonryWall>
) : (
    <TweetEmbed id={tweets[0]} options={{ align: 'center', cards: 'hidden' }} />
)

export default TweetEmbedComp
